import { Invoice } from '~hooks/useInvoices/models';
import { deriveScheduleLabel } from '~utils/deriveScheduleLabel';

export function getInvoiceRateCardName(invoice: Invoice) {
  return (
    invoice.rate?.name ??
    (invoice.siteRateSchedule ? deriveScheduleLabel(invoice.siteRateSchedule) : null)
  );
}
